import React from 'react'
import {Box } from 'grommet'
import ListShipments from '../../../components/listShipments'
import {withRouter} from 'react-router-dom'
import { NavigationSnackBar } from '../../../components/utils/shared/shared';

function AdminAllShipments (props) {
  return (
  <Box>
      <NavigationSnackBar title={'All Shipments'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
     <ListShipments displayQuote={props.displayQuote} user={props.user} />
   </Box>
  )
}

export default withRouter(AdminAllShipments)
